module.exports = __webpack_public_path__ + "img/drop_arrow.3352ab60.svg";